<template>
    <ul :id="id"
        class="scroll-view"
    >
        <template v-for="(listItem, index) in items">
            <slot
                name="item-tpl"
                :list-item="listItem"
                :index="index"
            >
                {{ listItem }}
            </slot>
        </template>

        <infinite-loading
            :identifier="identifier"
            spinner="waveDots"
            @infinite="infiniteHandler"
        >
            <slot slot="no-results"
                  name="noData"
            >
                No results
            </slot>
        </infinite-loading>
    </ul>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
    name: 'ScrollView',
    components: { InfiniteLoading },
    props: {
        id: {
            type: String,
            required: true,
        },
        identifier: {
            type: String,
            default: 'scroll-view',
        },
        dataProvider: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            items: [],
            uiPage: 1,
        };
    },
    computed: {
        pageSize() {
            return this.dataProvider.table.pageSize;
        },
    },
    watch: {
        identifier() {
            this.uiPage = 1;
            this.items = [];
        },
    },
    methods: {
        loadPage(page) {
            return this.dataProvider.fetch(page);
        },
        async infiniteHandler($state) {
            const items = await this.loadPage(this.uiPage);
            if (items.length) {
                const allItems = [].concat(this.items, items);
                this.uiPage += 1;
                this.items = allItems;
                $state.loaded();
                if (items.length < this.pageSize) {
                    $state.complete();
                }
            } else {
                $state.complete();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.scroll-view {
    @include unstyle-list;

    position: relative;
    margin: 0;
    background-color: $color-white;

    ::v-deep .infinite-loading-container {
        background-color: $color-background-light-4;
    }
}
</style>
